module.exports = __webpack_public_path__ + "img/bar-chart.4a5c2686.png";